<template>
  <div class="detail" v-if="showDeviceDetail">
    <div class="closeDetail" @click.prevent.stop="closeDetail">
      <i class="iconfont iconright"></i>
    </div>
    <header>
      <div class="title">
        {{ deviceList.deviceName }}
        <span :class="deviceList.status !== 1 ? 'iActive' : ''">
          <i></i>{{ deviceList.deviceStatusName }}
        </span>
      </div>
      <div class="detailContent">
        <div class="deviceIcon">
          <span
            ><i :class="'iconfont ' + (deviceList.icon || 'iconweidingyi-')"></i
          ></span>
        </div>
        <div>
          <p>设备编码：{{ deviceList.device_mark || deviceList.deviceId }}</p>
          <p>设备区域：{{ deviceList.region || deviceList.address }}</p>
        </div>
      </div>
    </header>
    <div class="information">
      <el-tabs v-model="activeName">
        <el-tab-pane label="设备信息" name="first">
          <videoPlayer
            :videoUrl="videoDetail.url"
            :id="videoDetail.deviceId"
            v-if="videoDetail.url"
            @openVideo="_openVideo"
          ></videoPlayer>
        </el-tab-pane>
        <el-tab-pane label="报警信息" name="second">
          <div class="searchTime">
            <el-date-picker
              v-model="startTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="date"
              placeholder="请选择开始时间"
            />
            -
            <el-date-picker
              v-model="endTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="请选择结束时间"
            />
            <div class="searchSubmit" @click.prevent.stop="_searchSubmit">
              <i style="color: #2f82b7" class="el-icon-search"></i>
            </div>
          </div>
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="startTime" label="报警时间" width="180">
            </el-table-column>
            <el-table-column prop="alarmDesc" label="报警内容">
            </el-table-column>
            <el-table-column prop="picUrl" label="图片">
              <template slot-scope="scope">
                <div v-if="!scope.row.picUrl">无</div>
                <div v-else>
                  <el-image
                    style="width: 60px; height: 60px;cursor: pointer;"
                    :key="0"
                    :src="scope.row.picUrl"
                    :preview-src-list="scope.row.picUrl.split(',')"
                  ></el-image>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100" align="left">
              <template slot-scope="scope">
                <el-tag
                  v-if="scope.row.alarmStatus !== 4"
                  type="warning"
                  size="small"
                  >未处理</el-tag
                >
                <el-tag v-else type="success" size="small">已处理</el-tag>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <play-video
      v-if="videoId"
      :deviceId="videoId"
      @closeVideo="closeVideo"
    ></play-video>
  </div>
</template>

<script>
  import videoPlayer from './video'
  export default {
    components: {
      videoPlayer,
      playVideo: () => import('./playVideo')
    },
    props: {
      deviceList: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    data() {
      return {
        showDeviceDetail: false,
        activeName: 'first',
        // 报警查询开始时间
        startTime: '',
        // 报警查询结束时间
        endTime: '',
        // 报警信息列表
        tableData: [],
        videoId: '',
        videoDetail: {
          url: '',
          deviceId: ''
        }
      }
    },
    methods: {
      checkDetail(e) {
        let { deviceId, id } = e
        this._deviceAlarm({ deviceId: deviceId })
        if (this.deviceList) {
          this.$axiosget('operation/configuration/findAll', {
            params: {
              pageNum: 1,
              pageSize: 10,
              deviceId: deviceId
            }
          }).then(res => {
            this.videoDetail.deviceId = id
            var ipAddr = window.location.href
            if (0 > ipAddr.indexOf('192.168')) {
              let standby_video_url = res.data.data.data.find(
                item => item.mark == 'standby_video_url'
              ).value
              // 如果是vpn环境
              // 改为vpn摄像头访问的地址
              if (standby_video_url != null) {
                this.videoDetail.url = standby_video_url
              }
              this.showDeviceDetail = true
            } else {
              let videoUrl = res.data.data.data.find(
                item => item.mark == 'video_url'
              ).value
              this.videoDetail.url = videoUrl
              this.showDeviceDetail = true
            }
          })
        }
      },
      _openVideo(id) {
        this.videoId = id
      },
      closeVideo() {
        this.videoId = ''
      },
      // 关闭设备详情
      closeDetail() {
        this.showDeviceDetail = false
      },
      // 报警信息搜索
      _searchSubmit() {
        let data = {
          startTime: this.startTime,
          endTime: this.endTime ? this.endTime + ' 23:59:59' : '',
          deviceId: this.deviceList.device_mark
        }
        this._deviceAlarm(data)
      },
      // 报警信息查询
      _deviceAlarm(params) {
        this.$axiospost(
          'operation/deviceAlarmApi/getAlarmNowPageList',
          params
        ).then(res => {
          this.tableData = res.data.data.list
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .detail {
    width: 510px;
    padding: 25px;
    position: absolute;
    z-index: 633;
    top: 50px;
    right: 20px;
    background: #0d1424d3;
    overflow: hidden;
    .detailContent {
      padding: 10px;
      display: flex;
      align-items: center;
      .deviceIcon {
        width: 50px;
        height: 50px;
        text-align: center;
        line-height: 50px;
        background: url('../imgaes/electric.png') no-repeat;
        background-size: contain;
        i {
          color: #00b9ff;
        }
      }
    }
    .closeDetail {
      position: absolute;
      left: 5px;
      top: 50%;
      z-index: 345;
      color: #36bfffb8;
      width: 20px;
      height: 20px;
      cursor: pointer;
    }
    header {
      .title {
        width: 100%;
        height: 40px;
        background: url('../imgaes/detailHeaderBg.png') no-repeat;
        color: #ccc;
        font-size: 16px;
        padding-left: 15px;
        padding-top: 5px;
        span {
          color: #01ef99;
          float: right;
          i {
            margin-right: 5px;
            display: inline-block;
            width: 10px;
            height: 10px;
            border-radius: 5px;
            background-color: #01ef99;
          }
        }
        .iActive {
          color: #ef0101;
          i {
            background-color: #ef0101;
          }
        }
      }
      p {
        padding-left: 20px;
        color: #cacaca;
        font-size: 14px;
        line-height: 40px;
      }
    }
    .device {
      padding-left: 10px;
      display: flex;
      .deviceList {
        border: 1px solid #172839;
        width: 120px;
        margin-right: 10px;
        .bg {
          text-align: center;
          font-size: 20px;
          line-height: 50px;
          color: #00b9ff;
          margin: 10px auto 0;
          width: 50px;
          height: 50px;
          background: url('../imgaes/electric.png') no-repeat;
          background-size: contain;
        }
        h6 {
          line-height: 30px;
          color: #61a1c3;
          text-align: center;
        }
        p {
          text-align: center;
          background: #042236;
          color: #126d9c;
          height: 35px;
          line-height: 35px;
        }
      }
    }
    .information {
      .searchTime {
        height: 60px;
        margin: 15px 0;
        padding: 10px;
        background: #1926435e;
        .searchSubmit {
          display: inline-block;
          width: 40px;
          height: 40px;
          border-radius: 50px;
          background-color: #283b65;
          text-align: center;
          line-height: 40px;
        }
      }
    }
    /deep/ .el-input__prefix {
      line-height: 40px;
    }
    /deep/ .el-table {
      height: 400px;
      background: #0d14240a;
    }
    /deep/ .el-table__body-wrapper {
      max-height: 340px;
      overflow: scroll;
      background-color: #0d142410;
    }
    .el-tag.el-tag--warning {
      color: #f67516;
      border: 1px solid #f67516;
      background: #3d2522;
    }
    .el-tag.el-tag--success {
      background: #0b0e1d;
      border: 1px solid #314081;
      color: #314081;
    }
    /deep/.el-date-editor.el-input,
    .el-date-editor.el-input__inner {
      width: 188px;
      color: #00b8f7;
    }
    /deep/ .el-input__inner {
      background-color: #141f3618;
      border-color: #253658;
    }
    /deep/ .el-tabs__nav-wrap::after {
      background-color: #161f32;
    }
    /deep/ .el-tabs__item {
      color: #ccc;
    }
    /deep/ .el-tabs__header {
      color: #218dd1;
    }
    /deep/ .el-tabs__item.is-active {
      border-bottom: #35b9f7;
    }
    /deep/ .el-table th {
      background: #1926431c;
      color: #35b9f7;
    }
    /deep/ .el-table tr {
      background: #0d15252a;
      color: #98a6c5;
    }
    /deep/.el-table td {
      border-bottom: 1px dashed #ccc;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute1/lv2/appMonitor/cameraDetail/index.vue